<template>
  <div class="bg-secondary d-flex p-3">
    <div class="" style="flex:1">
      <div class="d-flex justify-content-between ">
        <h5>Lotes Disponibles</h5>
        <base-input
          v-model="search"
          placeholder="Buscar..."
          inputClasses="input-group-alternative form-control-sm text-xs"
          class="mb-2"
          type="search"
        />
      </div>
      <ag-grid-vue
        v-bind="agLotesDisponibles"
        @grid-ready="onGridReady($event, 'apiLotesDisponibles')"
        class="ag-theme-alpine small-table"
        style="height: 200px;"
      />
    </div>
    <div
      class="mx-3 h-full d-flex flex-column align-items-center justify-content-center"
    >
      <base-button
        @click="moveToSelected"
        size="sm"
        icon="fa fa-arrow-right"
        type="secondary"
        class="m-0 mb-3"
      >
      </base-button>
      <base-button
        @click="returnToAvailable"
        size="sm"
        icon="fa fa-arrow-left"
        type="secondary"
        class="m-0"
      >
      </base-button>
    </div>
    <div
      class="h-full d-flex flex-column justify-content-between"
      style="flex:1"
    >
      <h5>Lotes Seleccionados *</h5>
      <ag-grid-vue
        v-bind="agLotesSeleccionados"
        @grid-ready="onGridReady($event, 'apiLotesSeleccionados')"
        class="ag-theme-alpine small-table"
        style="height: 200px;"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import Formats from "@/mixins/Formats";
export default {
  mixins: [Formats],
  components: {
    AgGridVue,
  },
  props: {
    availableBatches: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      apiLotesDisponibles: null,
      agLotesDisponibles: {
        rowData: null,
        columnDefs: [
          {
            headerName: "Lote",
            field: "BatchNum",
            flex: 6,
            cellClass: "font-weight-bold",
          },
          {
            headerName: "Cant. Disponible",
            field: "Quantity",
            headerTooltip: "Cantidad Disponible",
            flex: 3,
            type: "rightAligned",
            valueFormatter: (params) => this.numberFormat(params.value),
          },
          {
            headerName: "Cant. Seleccionada",
            field: "selected",
            headerTooltip: "Cantidad Seleccionada",
            valueFormatter: (params) => params.value ? this.numberFormat(params.value) : 'Editar...',
            tooltipValueGetter: () => 'Editar',
            cellClass: (params) => params.value ? 'ag-editable-cell text-right' : 'ag-editable-cell',
            type: "rightAligned",
            cellEditor: 'agNumberCellEditor',
            valueSetter: params => {
              if(params.newValue <= params.data.Quantity){
                params.data.selected = params.newValue;
                return true;
              }
            },
            flex: 3,
            editable: true,
          },
        ],
        noRowsOverlayComponent: "EmptySection",
        loadingOverlayComponent: "BaseLoader",
        rowSelection: "multiple",
        tooltipShowDelay: 0,
        rowMultiSelectWithClick: true,
        singleClickEdit: true,
        stopEditingWhenCellsLoseFocus: true,
        cacheQuickFilter: true,
        suppressCellFocus: true,
        defaultColDef: {
          suppressHeaderMenuButton: true,
          resizable: false,
          sortable: false,
        },
      },
      apiLotesSeleccionados: null,
      agLotesSeleccionados: {
        rowData: [],
        columnDefs: [
          {
            headerName: "Lote",
            field: "BatchNum",
            flex: 2,
            cellClass: "font-weight-bold",
          },
          {
            headerName: "Cantidad Seleccionada",
            field: "selected",
            flex: 1,
          },
        ],
        noRowsOverlayComponent: "EmptySection",
        loadingOverlayComponent: "BaseLoader",
        rowSelection: "multiple",
        tooltipShowDelay: 0,
        rowMultiSelectWithClick: true,
        suppressCellFocus: true,
        defaultColDef: {
          suppressHeaderMenuButton: true,
          resizable: false,
          sortable: false,
          enableCellChangeFlash: true,
        },
      },
    };
  },
  created(){
    this.agLotesDisponibles.rowData = this.availableBatches;
  },
  methods: {
    onGridReady(params, grid) {
      // console.log("GRID READY");
      this[grid] = params.api;
      this[grid].sizeColumnsToFit();
    },
    moveToSelected() {
      this.apiLotesDisponibles.getSelectedRows().forEach((row) => {
        this.apiLotesSeleccionados.applyTransaction({ add: [row] });
        this.apiLotesDisponibles.applyTransaction({ remove: [row] });
      });
      this.emitUpdate();
    },
    returnToAvailable() {
      this.apiLotesSeleccionados.getSelectedRows().forEach((row) => {
        this.apiLotesDisponibles.applyTransaction({ add: [row] });
        this.apiLotesSeleccionados.applyTransaction({ remove: [row] });
      });
      this.emitUpdate();
    },
    emitUpdate(){
      const rowData = [];
      this.apiLotesSeleccionados.forEachNode((node) => {
        rowData.push(node.data);
      });
      const selectedBatches = rowData.map(({ BatchNum, selected }) => ({ BatchNum, selected }));
      this.$emit("update", selectedBatches);
      this.apiLotesDisponibles.sizeColumnsToFit();
      this.apiLotesSeleccionados.sizeColumnsToFit();
    }
  },
  watch: {
    search(newValue) {
      this.apiLotesDisponibles.setGridOption("quickFilterText", newValue);
      this.apiLotesDisponibles.sizeColumnsToFit();
    },
  },
};
</script>

<style lang="scss">
.ag-theme-alpine.small-table {
  --ag-font-size: 11px;
  --ag-cell-horizontal-padding: 8px;
  --ag-header-background-color: #e2e8f0;
}

.ag-editable-cell {
  cursor: text;
}
.ag-editable-cell:hover {
  background: #cbd5e1;
}
</style>
